import React from 'react';
import styled from 'styled-components';
import tag from 'clean-tag';
import Container from '../Layout/Container';
import { Box, Flex } from '../Layout';
import { Link } from '../Typography';
import ibsaLogo from '../images/ibsa.jpg';

const IbsaLogo = styled(tag.img)`
  height: 80px;
`;

const About = () => (
  <Container>
    <Box>
      <h1>About</h1>
      <h2>What is Australian Blind Football</h2>
      <p>
        Australian Blind Football is an initiative of Blind Sports Australia <Link href='http://www.blindsportsaustralia.com.au/'>http://www.blindsportsaustralia.com.au/</Link> and is working with Football Federation
        Australia (FFA) to be the recognised national pathway by for people who are blind or vision impaired to play
        football for Australia.
      </p>
      <p>
        There are two versions of the game of blind football. Blind football (B1 or 5 a side football) is played by
        athletes who are totally blind. Vision impaired futsal (partially sighted futsal) is played by athletes who are
        vision impaired.
      </p>
      <p>Our purpose is to:</p>
      <ul>
        <li>
          Provide national camps for blind football and partially sighted futsal and to prepare national teams for
          international competition;
        </li>
        <li>Organise and coordinate international tour's and tournaments, either in Australia oroverseas;</li>
        <li>
          Develop and support grassroots participation opportunities for people of all ages, genders, abilities and
          levels of vision loss to play football.
        </li>
      </ul>
      <p>
        <strong>Note:</strong> Australian Blind Football will not be responsible for the development and ongoing
        management of state based programs. State based programs will be coordinated by partnerships between state based
        blind sport and football organisations, with Australian Blind Football providing support and advice through
        initial implementation and throughout their development.
      </p>
      <p>
        Blind football is experiencing massive growth across the globe with support from the International Blind Sports
        Federation (IBSA). We will also work closely with IBSA to increase participation in blind football in Australia,
        while also being a leader and advocate for further development of the game across Asia and Oceania.
      </p>
    </Box>
    <Box>
      <h2>What is blind football?</h2>
      <p>
        Blind football is played by athletes who are blind or vision impaired. Internationally the sport is governed by
        the International Blind Sports Federation (IBSA).
      </p>
      <p>
        There are two formats of the game, blind football (B1) and partially sighted/vision impaired football (B2/B3).
      </p>
      <p>
        Blind Football (B1) is an internationally recognised sport played at the Paralympics. It is played outdoors by
        athletes who are totally blind (B1) on a 40m x 20m pitch with side kickboards and an audible ball. There are two
        teams of five; four outfield players and a goalkeeper. The outfield players wear eye-shades to equal their sight
        and the goalkeeper can be fully or partially sighted. 
        For Blind Football, outfield athletes must be B1, which as a guide only, means athletes are blind and have no light perception in both eyes. Impairment of the eye structure, optic nerves or pathways, or vision area of the brain, resulting in a loss of vision in both eyes. 
      </p>
      <p>
        Partially sighted/vision impaired football (B2/B3) is played by athletes who are vision impaired with rules
        similar to futsal with particular attention towards ensuring equal light on the court and utilising a futsal
        ball that provides good contrast with the playing surface. 
        B2 vision impairment (as a guide only) has the ability to recognise objects up to a distance of 2 metres, visual acuity ranges from LogMAR 1.5 to 2.60 (below 2/60) with best corrected vision; and/or v isual field of less than ten (10) degrees diameter.
        B3 vision impairment (as a guide only) can recognise contours between 2 and 6 metres away. Visual acuity ranges from LogMAR 1.40 – 1.0 (2/60 – 6/60) with best corrected vision; and/or visual field of more than ten (10) degrees and less than forty (40) degrees diameter.
      </p>
    </Box>
    <Flex>
      <Box>
        <Link href="http://www.ibsasport.org/sports/football/">
          <IbsaLogo src={ibsaLogo} alt="International Blind Sports Federation Logo" />
        </Link>
      </Box>
      <Box ml={10}>
        <p>
          Visit <Link href="http://www.ibsasport.org/sports/football/">http://www.ibsasport.org/sports/football/</Link>
          <br />
          for more information on blind football.
        </p>
      </Box>
    </Flex>
  </Container>
);

export default About;



// WEBPACK FOOTER //
// ./src/About/About.js